module.exports = __webpack_public_path__ + "packs/media/images/Invitation_Status-c7d80c0a4c4a3ef86d9f506fa12f5733.png";